/* pages/Home.jsx (UPDATED: 🇨🇦 flag in "Licensed Expert" icon & badge for main page emphasis) */
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom'; 
import { motion } from 'framer-motion';

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Our Financial Success | Family Wealth Harmony in Canada</title>
        <meta name="description" content="Licensed experts building community and financial success for Canadian families." />
      </Helmet>

      {/* Hero Section */}
       <motion.section
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="relative min-h-[85vh] md:min-h-[80vh] bg-cover bg-center bg-no-repeat bg-gray-900 image-blur-fix"
        style={{ 
          // REMOVED: backgroundAttachment (main blur cause)
          // Kept optimized image (fast + sharp)
          backgroundImage: 'url("https://images.unsplash.com/photo-1476703993599-0035a21b17a9?auto=format&fit=crop&q=70&w=1200&sharpen=1")' 
        }}
        variants={fadeInUp}
      >
        {/* Enhanced Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-950/85 via-black/65 to-amber-900/65" />
        
        <div className="relative max-w-6xl mx-auto text-center flex items-center justify-center min-h-[85vh] md:min-h-[80vh] py-20 px-6">
          <motion.div variants={fadeInUp} className="text-white drop-shadow-2xl">
            <h1 className="text-5xl md:text-7xl font-black mb-8 tracking-tightest">
              Build <span className="text-amber-400 bg-gradient-to-r from-amber-400 to-amber-200 bg-clip-text">Lasting</span><br />Family Wealth
            </h1>
            <p className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto opacity-95 leading-relaxed font-light text-white/90">
              Government-licensed to create financial harmony for families across 🇨🇦 Canada.
              We take everything you already do and elevate it for enhanced success.
            </p>
            <Link 
              to="/contact" 
              className="inline-block btn-primary text-xl lg:text-2xl px-12 py-6 shadow-2xl rounded-3xl bg-gradient-to-r from-emerald-600 via-emerald-500 to-emerald-700 hover:from-emerald-700 hover:to-emerald-600 font-black tracking-wide transition-all duration-300 hover:shadow-3xl hover:-translate-y-1 hover:scale-[1.02] active:scale-[0.98] whitespace-nowrap"
            >
              Start Your Journey
            </Link>
          </motion.div>
        </div>
      </motion.section>

      {/* Trust Section - UPDATED: 🇨🇦 in Licensed Expert */}
      <motion.section
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="py-32 px-6 bg-gradient-to-b from-gray-50 to-white"
        variants={fadeInUp}
      >
        <div className="max-w-6xl mx-auto">
          <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-20 text-gray-800">
              Your Partner in Prosperity
            </h2>
          </motion.div>
          <div className="grid md:grid-cols-3 gap-12">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              className="text-center group hover:scale-105 transition-all duration-300"
            >
              <div className="w-24 h-24 bg-emerald-100 rounded-3xl mx-auto mb-8 flex items-center justify-center group-hover:bg-emerald-200 transition">
                <span className="text-3xl">🏆🇨🇦</span> {/* NEW: Flag badge */}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Licensed Expert</h3>
              <p className="text-lg text-gray-600">Fully government-approved for Canada-wide service.</p>
            </motion.div>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              variants={fadeInUp}
              className="text-center group hover:scale-105 transition-all duration-300"
            >
              <div className="w-24 h-24 bg-emerald-100 rounded-3xl mx-auto mb-8 flex items-center justify-center group-hover:bg-emerald-200 transition">
                <span className="text-3xl">👨‍👩‍👧‍👦</span>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Family Harmony</h3>
              <p className="text-lg text-gray-600">Tailored wealth strategies for lasting legacy.</p>
            </motion.div>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              variants={fadeInUp}
              className="text-center group hover:scale-105 transition-all duration-300"
            >
              <div className="w-24 h-24 bg-amber-100 rounded-3xl mx-auto mb-8 flex items-center justify-center group-hover:bg-amber-200 transition">
                <span className="text-3xl">📈</span>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">Enhanced Success</h3>
              <p className="text-lg text-gray-600">Optimize your current steps for bigger wins.</p>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* CTA */}
      <motion.section
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="py-24 px-6 bg-gradient-to-r from-emerald-600 to-amber-600 text-white text-center"
        variants={fadeInUp}
      >
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold mb-8">Ready to Build Your Legacy?</h2>
          <Link to="/contact" className="btn-primary text-xl inline-block">
            Book Free Consultation
          </Link>
        </div>
      </motion.section>
    </>
  );
}